// Uitklaplijst bij "Mast optie" op de PDP, Figma node 1136:644.
//
// Bewust niet variant-dropdown.js: dat element opent een schermbrede lade met
// een donkere laag eronder en verwacht die laag als voorgaand element. Hier
// staan er maar twee regels in, en het zijn links naar een andere
// productpagina en geen variantkeuze.
if (!customElements.get("lumedi-mast-option")) {
  customElements.define(
    "lumedi-mast-option",
    class LumediMastOption extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector(".lumedi-mast-option__trigger");
        this.list = this.querySelector(".lumedi-mast-option__list");
        this.label = this.querySelector(".lumedi-mast-option__trigger-label");
        if (!this.trigger || !this.list || !this.label) return;

        // Bij een herplaatsing in de DOM komt deze callback nog een keer
        // langs. De vastgelegde verwijzingen blijven dan hetzelfde, en een
        // tweede addEventListener met dezelfde functie doet niets; opnieuw
        // binden zou wel een nieuwe functie opleveren en dus dubbel hangen.
        if (!this.bound) {
          this.bound = true;
          this.onTriggerClick = this.onTriggerClick.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
        }

        this.trigger.addEventListener("click", this.onTriggerClick);
        this.addEventListener("keydown", this.onKeyDown);
        document.addEventListener("click", this.onDocumentClick);
      }

      disconnectedCallback() {
        document.removeEventListener("click", this.onDocumentClick);
      }

      get isOpen() {
        return this.trigger.getAttribute("aria-expanded") === "true";
      }

      open() {
        this.trigger.setAttribute("aria-expanded", "true");
        this.setLabel(this.dataset.labelOpen);
        this.list.querySelector("a")?.focus();
      }

      close() {
        this.trigger.setAttribute("aria-expanded", "false");
        this.setLabel(this.dataset.labelClosed);
      }

      // Twee keer rAF: bij een enkele vallen het zetten en het weghalen van de
      // klasse in dezelfde schilderbeurt en blijft de overgang uit.
      setLabel(text) {
        if (this.label.textContent === text) return;

        this.label.classList.add("lumedi-mast-option__trigger-label--swapping");
        this.label.textContent = text;

        requestAnimationFrame(() => {
          requestAnimationFrame(() => {
            this.label.classList.remove(
              "lumedi-mast-option__trigger-label--swapping",
            );
          });
        });
      }

      onTriggerClick(event) {
        event.preventDefault();
        if (this.isOpen) this.close();
        else this.open();
      }

      onDocumentClick(event) {
        if (this.isOpen && !this.contains(event.target)) this.close();
      }

      onKeyDown(event) {
        if (event.key === "Escape" && this.isOpen) {
          this.close();
          this.trigger.focus();
        }
      }
    },
  );
}

// Tooltip achter de titel "Mast optie". Zweven en toetsenbordfocus regelt de
// CSS; deze klasse is er voor het aantikken op een aanraakscherm, waar geen
// van beide gebeurt.
if (!customElements.get("lumedi-mast-tooltip")) {
  customElements.define(
    "lumedi-mast-tooltip",
    class LumediMastTooltip extends HTMLElement {
      connectedCallback() {
        this.trigger = this.querySelector(".lumedi-mast-tooltip__icon");
        this.bubble = this.querySelector(".lumedi-mast-tooltip__bubble");
        if (!this.trigger) return;

        if (!this.bound) {
          this.bound = true;
          this.onTriggerClick = this.onTriggerClick.bind(this);
          this.onDocumentClick = this.onDocumentClick.bind(this);
          this.onKeyDown = this.onKeyDown.bind(this);
          this.position = this.position.bind(this);
        }

        this.trigger.addEventListener("click", this.onTriggerClick);
        this.addEventListener("keydown", this.onKeyDown);
        // Zweven en toetsenbordfocus tonen de ballon buiten deze klasse om,
        // dus de meting hangt ook aan die twee en niet alleen aan het
        // aantikken.
        this.addEventListener("pointerenter", this.position);
        this.addEventListener("focusin", this.position);
        document.addEventListener("click", this.onDocumentClick);
        window.addEventListener("resize", this.position);
        this.position();
      }

      disconnectedCallback() {
        document.removeEventListener("click", this.onDocumentClick);
        window.removeEventListener("resize", this.position);
      }

      // De ballon hangt aan de titelregel en weet zelf niet waar die in de
      // pagina staat. Deze meting schuift hem via --lumedi-tooltip-shift
      // terug in beeld; past hij niet tussen de randen, zoals op mobiel waar
      // hij bijna schermbreed is, dan komt hij midden in beeld te staan.
      position() {
        if (!this.bubble) return;

        const margin = 8;
        this.bubble.style.setProperty("--lumedi-tooltip-shift", "0px");

        const rect = this.bubble.getBoundingClientRect();
        const viewport = document.documentElement.clientWidth;
        let shift = 0;

        if (rect.width > viewport - margin * 2) {
          shift = viewport / 2 - (rect.left + rect.width / 2);
        } else {
          if (rect.right > viewport - margin) {
            shift = viewport - margin - rect.right;
          }
          if (rect.left + shift < margin) shift = margin - rect.left;
        }

        this.bubble.style.setProperty(
          "--lumedi-tooltip-shift",
          Math.round(shift) + "px",
        );
      }

      get isOpen() {
        return this.classList.contains("lumedi-mast-tooltip--open");
      }

      toggle(open) {
        if (open) this.position();
        this.classList.toggle("lumedi-mast-tooltip--open", open);
        this.trigger.setAttribute("aria-expanded", open ? "true" : "false");
      }

      onTriggerClick(event) {
        event.preventDefault();
        this.toggle(!this.isOpen);
      }

      onDocumentClick(event) {
        if (this.isOpen && !this.contains(event.target)) this.toggle(false);
      }

      onKeyDown(event) {
        if (event.key === "Escape" && this.isOpen) {
          this.toggle(false);
          this.trigger.focus();
        }
      }
    },
  );
}
